var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1214_2415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 12.6901V14.9401C16.5009 15.1489 16.4581 15.3557 16.3744 15.5471C16.2907 15.7385 16.168 15.9103 16.0141 16.0515C15.8602 16.1927 15.6784 16.3002 15.4806 16.3671C15.2827 16.434 15.073 16.4589 14.865 16.4401C12.5571 16.1893 10.3403 15.4007 8.39251 14.1376C6.58038 12.9861 5.04401 11.4497 3.89251 9.63757C2.62499 7.68098 1.83619 5.45332 1.59001 3.13507C1.57127 2.92767 1.59592 2.71864 1.66239 2.52129C1.72886 2.32394 1.83569 2.14259 1.97609 1.98879C2.11648 1.83499 2.28736 1.7121 2.47785 1.62796C2.66834 1.54382 2.87427 1.50027 3.08251 1.50007H5.33251C5.69649 1.49649 6.04935 1.62538 6.32533 1.86272C6.60131 2.10006 6.78157 2.42966 6.83251 2.79007C6.92748 3.51012 7.1036 4.21712 7.35751 4.89757C7.45842 5.16602 7.48026 5.45776 7.42044 5.73823C7.36062 6.01871 7.22166 6.27616 7.02001 6.48007L6.06751 7.43257C7.13518 9.31023 8.68985 10.8649 10.5675 11.9326L11.52 10.9801C11.7239 10.7784 11.9814 10.6395 12.2619 10.5796C12.5423 10.5198 12.8341 10.5417 13.1025 10.6426C13.783 10.8965 14.49 11.0726 15.21 11.1676C15.5743 11.219 15.9071 11.4025 16.1449 11.6832C16.3828 11.9639 16.5091 12.3223 16.5 12.6901Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1214_2415"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.cefd558fb3cf56b8382fef77b198f01f.svg";
export { ForwardRef as ReactComponent };